function  mostrarsocial(){
    // alert('hola mundo');
    dialogDiv.style.display = 'block';
}

function nomostrarsocial(){
    dialogDiv.style.display = 'none';
}
const dialogDiv = document.createElement("div");
dialogDiv.id = "smDialogDiv";

const dialogClicker = document.createElement("div");



function closeDialogDiv(){
    dialogClicker.style.width = '40px';
    dialogClicker.style.height = '40px';
    dialogClicker.style.position = 'absolute';
    dialogClicker.style.bottom = '10px';
    dialogClicker.style.right = '10px';
    dialogClicker.style.zIndex = '1000';
    dialogClicker.style.display = "block";
    dialogClicker.style.borderRadius = '100%';
    dialogClicker.style.cursor= 'pointer';

    dialogDiv.style.removeProperty('inset');
    dialogDiv.style.removeProperty('transform');
    dialogDiv.style.width = '40px';
    dialogDiv.style.height = '40px';
    dialogDiv.style.position = 'absolute';
    dialogDiv.style.bottom = '10px';
    dialogDiv.style.right = '10px';
    dialogDiv.style.display = 'block';
    iframe.style.borderRadius = '100%';
    

    closeButton.style.display = "none";
    dialogClicker.addEventListener('click', function() {
        console.log("div");
        openDialogDiv();
    });

}

function openDialogDiv(){
    dialogClicker.style.display = "none";
    dialogDiv.style.width = '90vw';
    dialogDiv.style.height = '80vh';
    dialogDiv.style.position = 'absolute';
    dialogDiv.style.top = '50%';
    dialogDiv.style.left = '50%';
    dialogDiv.style.transform = 'translate(-50%, -50%)';
    iframe.style.removeProperty('border-radius');
    closeButton.style.display = "block";
}

const closeButton = document.createElement("div");
closeButton.innerHTML = "x";
closeButton.style.position = "fixed";
closeButton.style.right = "0px";
closeButton.style.top = "-30px";
closeButton.style.cursor= 'pointer';
closeButton.style.fontSize = '30px';
closeButton.style.color = 'black';
closeButton.style.fontFamily = 'monospace';
closeButton.addEventListener('click', function() {
    closeDialogDiv();
});




const iframe = document.createElement('iframe');
iframe.src = 'https://libertycr-social.isoft-ste.com';
iframe.width = '100%';
iframe.height = '100%';
iframe.style.border = 'none';

dialogDiv.appendChild(iframe);
dialogDiv.appendChild(closeButton);
document.body.appendChild(dialogDiv);
document.body.appendChild(dialogClicker);

closeDialogDiv();
dialogDiv.style.display = 'none';